export default {
  // bonded loan
  SET_BONDED_LOAN (state, loan) {
    state.bondedLoan = loan
  },
  // photo
  LOAD_BONDED_LOAN_PHOTO ({ bondedLoan }, { photo }) {
    if (bondedLoan) {
      bondedLoan.photo = photo
    }
  },
  // advantage
  ADD_BONDED_LOAN_ADVANTAGE ({ bondedLoan }, advantage) {
    bondedLoan.advantages.push(advantage)
  },
  DELETE_BONDED_LOAN_ADVANTAGE ({ bondedLoan }, id) {
    bondedLoan.advantages = bondedLoan.advantages.filter(advantage => advantage.id !== id)
  },
  UPDATE_BONDED_LOAN_ADVANTAGE (
    { bondedLoan },
    { id, title, description, videoPreview, videoLink, buttonLink, buttonTitle, order, newPhoto }
  ) {
    const advantage = bondedLoan.advantages.find(advantage => advantage.id === id)
    Object.assign(
      advantage,
      { id, title, description, videoPreview, videoLink, buttonLink, buttonTitle, order, newPhoto }
    )
  },
  UPDATE_BONDED_LOAN_ADVANTAGES ({ bondedLoan }, advantages) {
    bondedLoan.advantages = advantages
  },
  CHANGE_BONDED_LOAN_ADVANTAGE_PREVIEW ({ bondedLoan }, { id, photo }) {
    if (bondedLoan) {
      const advantage = bondedLoan.advantages.find(advantage => advantage.id === id)
      advantage.videoPreview = photo
    }
  },
  // letter
  ADD_BONDED_LOAN_LETTER ({ bondedLoan }, letter) {
    bondedLoan.letters.push(letter)
  },
  DELETE_BONDED_LOAN_LETTER ({ bondedLoan }, id) {
    bondedLoan.letters = bondedLoan.letters.filter(letter => letter.id !== id)
  },
  UPDATE_BONDED_LOAN_LETTER ({ bondedLoan }, { id, type, file, preview, order, title }) {
    const letter = bondedLoan.letters.find(letter => letter.id === id)
    Object.assign(
      letter,
      { id, type, file, preview, order, title }
    )
  },
  UPDATE_BONDED_LOAN_LETTERS ({ bondedLoan }, letters) {
    bondedLoan.letters = letters
  },
  CHANGE_BONDED_LOAN_LETTER_FILE ({ bondedLoan }, {id, file, newFile}) {
    const letter = bondedLoan.letters.find(l => l.id === id)
    if (letter) {
      Object.assign(letter, {file, newFile})
    }
  },
  CHANGE_BONDED_LOAN_LETTER_PREVIEW ({ bondedLoan }, { id, photo }) {
    if (bondedLoan) {
      const letter = bondedLoan.letters.find(l => l.id === id)
      letter.preview = photo
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/bondedLoan.js